import React from "react";
import { HOME } from "@/constants/testIds";
import { AlertCircle, CalendarClock, FileSearch, ClipboardX } from "lucide-react";

export const Problem = () => {
  const items = [
    { icon: CalendarClock, title: "How delays affect operations",  copy: "A two-day vessel delay means production planning, customs filings and warehouse slots all shift." },
    { icon: AlertCircle,   title: "Which milestone comes next",    copy: "Loading, sailing, arrival, customs — your team needs to act before each, not react after." },
    { icon: FileSearch,    title: "Whether documents are ready",   copy: "Bills of lading, certificates of origin and insurance — all in the right place at the right time." },
    { icon: ClipboardX,    title: "Whether inspections are complete", copy: "Pre-shipment, container loading and quality reports — tied directly to the shipment." },
  ];

  return (
    <section
      id="problem"
      data-testid={HOME.problemSection}
      className="relative py-24 md:py-32 border-t border-ink-10"
    >
      <div className="container-narrow grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="text-[11px] font-mono uppercase tracking-[0.18em] ink-soft mb-4">
            01 — The Problem
          </div>
          <h2 className="font-display text-4xl lg:text-5xl font-semibold ink leading-[1.05] text-balance">
            Knowing where your container is isn&apos;t enough.
          </h2>
          <p className="mt-5 text-[15px] ink-soft leading-relaxed max-w-md">
            Traditional carrier portals tell you a location. Importers need to know
            what that location <em>means</em>. Live Shipment Tracking™ turns position
            into operational context.
          </p>
        </div>

        <ul className="lg:col-span-7 grid sm:grid-cols-2 gap-3">
          {items.map((it) => {
            const I = it.icon;
            return (
              <li
                key={it.title}
                className="group rounded-2xl bg-white border border-ink-10 p-5 hover:border-[hsla(217,71%,35%,0.35)] transition-colors"
              >
                <div className="flex items-center gap-3 mb-3">
                  <span className="grid h-8 w-8 place-items-center rounded-lg bg-ink-3 text-ink group-hover:bg-emerald/10 group-hover:text-emerald transition-colors">
                    <I className="h-4 w-4" />
                  </span>
                  <h3 className="font-display text-[15px] font-semibold ink">{it.title}</h3>
                </div>
                <p className="text-[13.5px] ink-soft leading-relaxed">{it.copy}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
